import { render, staticRenderFns } from "./serviceinfo.vue?vue&type=template&id=f264c82c&"
import script from "./serviceinfo.vue?vue&type=script&lang=js&"
export * from "./serviceinfo.vue?vue&type=script&lang=js&"
import style0 from "./serviceinfo.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports